/* eslint-disable
    no-cond-assign,
    no-loop-func,
    no-restricted-globals,
    no-return-assign,
    no-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import * as CRISPRConstants from 'constants/CRISPRConstants';
import {Chromosome, Gene, Genome, Transcript} from 'constants/GenomeConstants';
import FolderSelector, {DEFAULT_PROJECT_FOLDER_LABEL_TEXT} from 'file-browser/FolderSelector';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import HelpTooltip from 'help/HelpTooltip';
import GenomeImportHelpText from 'molbio/genome/GenomeImportHelpText';
import notifications, {Response} from 'notifications';
import getTestProps from 'test/lib/cypress/getTestProps';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import SearchInput from 'ui-library/SearchInput';
import * as GenomeUtil from 'util/GenomeUtil';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';
import {Optional, SelectChangeEvent} from 'util/Types';

const {geneToName, genomeToName, locationToName, transcriptToName} = GenomeUtil;

const EXAMPLE_QUERY = 'ENSMUSG00000041147';

interface ImportGeneInputProps {
  initialUpstream: number;
  initialDownstream: number;
  enableAdvancedSettings: boolean;
}

interface GeneState {
  selectedGeneId: string | null;
  revcomp: boolean;
  selectedTranscriptIds: Array<string> | null;
  sequenceName: string;
}

interface State extends GeneState {
  query: string | null;
  loading: boolean;
  upstream: string;
  downstream: string;
  folderId: Optional<string>;
  cdna: boolean;
  showAdvancedSettings: boolean;
  result: GeneSearchResponse | null;
}

interface GeneVersion {
  genome: Genome;
  chromosome: Chromosome;
  gene: Gene;
  transcripts: Array<Transcript>;
}
interface GeneSearchResponse {
  ensemblId: string;
  versions: Array<GeneVersion>;
}

class ImportGeneInput extends React.Component<ImportGeneInputProps, State> {
  static defaultProps = {
    enableAdvancedSettings: true,
    initialUpstream: 0,
    initialDownstream: 0,
  };

  _isMounted!: boolean;
  lastXHR?: JQueryPromise<GeneSearchResponse | Response>;

  searchRef = React.createRef<SearchInput>();

  getState = (props: ImportGeneInputProps): State => ({
    query: null,
    loading: false,
    result: null,
    selectedGeneId: null,
    selectedTranscriptIds: null,
    upstream: `${props.initialUpstream}`,
    downstream: `${props.initialDownstream}`,
    sequenceName: '',
    folderId: FolderDefaults.get(FolderDefaultsKey.INVENTORY),
    revcomp: false,
    cdna: false,
    showAdvancedSettings: false,
  });

  override componentDidMount(): void {
    this._isMounted = true;
    // The modal isn't showing yet when componentDidMount.
    _.defer(() => {
      if (this._isMounted) {
        this.searchRef.current!.focus();
      }
    });
  }

  override componentWillUnmount(): void {
    this._isMounted = false;
  }

  override UNSAFE_componentWillReceiveProps(nextProps: ImportGeneInputProps): void {
    if (
      nextProps.initialUpstream !== this.props.initialUpstream ||
      nextProps.initialDownstream !== this.props.initialDownstream ||
      nextProps.enableAdvancedSettings !== this.props.enableAdvancedSettings
    ) {
      this.setState(this.getState(nextProps));
    }
  }

  getDefaultTranscript = (version: GeneVersion): Transcript => {
    let left;
    return (left = _.findWhere(version.transcripts, {default: true})) != null ? left : version.transcripts[0];
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types
  createSequence = () => {
    const upstream = parseInt(this.state.upstream, 10);
    const downstream = parseInt(this.state.downstream, 10);
    if (this.state.selectedGeneId == null) {
      notifications.error('Find a gene to continue.');
      return;
    }
    if (!(this.state.sequenceName.trim().length > 0 && this.state.folderId != null)) {
      notifications.error('Name and folder must be specified.');
      return;
    }
    if (isNaN(upstream) || isNaN(downstream)) {
      notifications.error('Enter a valid number of upstream and downstream bases.');
      return;
    }
    if (upstream < 0 || downstream < 0) {
      notifications.error('Number of upstream and downstream bases cannot be negative.');
      return;
    }
    const sequence = {
      folder_id: this.state.folderId,
      name: this.state.sequenceName,
      accession: {
        gene: this.state.selectedGeneId,
        transcripts: this.state.selectedTranscriptIds,
        upstream,
        downstream,
      },
      cdna: this.state.cdna,
      revcomp: this.state.revcomp,
    };
    return TaskRunner.runTask({
      url: '/1/api/dbimport',
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        sequences: [sequence],
      }),
    }).then(({results}) => results[0].id);
  };

  getGenome = (): Genome => {
    // eslint-disable-next-line no-restricted-syntax
    const version = _.find(this.state.result!.versions, ({gene}) => gene.id === this.state.selectedGeneId);
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    return version.genome;
  };

  getGeneVersion = (versions: Array<GeneVersion> | null): GeneVersion | null => {
    if (versions == null) {
      return null;
    }
    for (var genome of Array.from(CRISPRConstants.DEFAULTS.GENOME_PREFERENCES)) {
      const genomeVersions = versions.filter((version: GeneVersion) => version.genome.ensemblName === genome);
      if (genomeVersions.length > 0) {
        return genomeVersions[0];
      }
    }
    return versions[0];
  };

  search = (query: string | null): void => {
    if (query == null) {
      this.setState(
        // eslint-disable-next-line no-restricted-syntax
        _.extend(this.geneState(null), {
          query,
          loading: false,
          result: null,
        })
      );
      return;
    }
    this.setState({query, loading: true});
    var xhr = net
      .getJSON('/1/api/genes/search', {q: query})
      .done((result: GeneSearchResponse) => {
        if (this._isMounted) {
          const version = this.getGeneVersion(result.versions);
          // eslint-disable-next-line no-restricted-syntax
          this.setState(_.extend(this.geneState(version), {result, loading: false}));
        }
      })
      .fail((res: Response) => {
        if (xhr !== this.lastXHR) {
          // If the XHR was aborted, don't notify error.
          return;
        }
        notifications.notifyError(res);
        if (this._isMounted) {
          this.setState({loading: false});
        }
      });

    const oldLastXHR = this.lastXHR;
    this.lastXHR = xhr;
    if (oldLastXHR != null) {
      // @ts-expect-error: this object is in fact a JQueryXHR so this is safe.
      oldLastXHR.abort();
    }
  };

  searchExample = (): void => {
    this.setState({query: EXAMPLE_QUERY});
    this.search(EXAMPLE_QUERY);
  };

  handleVersionChange = (e: SelectChangeEvent): void => {
    this.setState(
      // eslint-disable-next-line no-restricted-syntax
      this.geneState(_.find(this.state.result!.versions, ({gene}) => gene.id === e.target.value))
    );
  };

  geneState = (version: GeneVersion | null | undefined): GeneState => {
    if (version != null) {
      return {
        selectedGeneId: version.gene.id,
        revcomp: version.gene.strand === -1,
        selectedTranscriptIds: _.compact([
          __guard__(this.getDefaultTranscript(version), (x: Transcript) => x.id),
        ]),
        sequenceName: geneToName(version.gene),
      };
    } else {
      return {
        selectedGeneId: null,
        revcomp: false,
        selectedTranscriptIds: [],
        sequenceName: '',
      };
    }
  };

  toggleAdvancedSettings = (): void => {
    if (this.state.showAdvancedSettings && this.state.selectedTranscriptIds!.length > 1) {
      this.setState({
        selectedTranscriptIds: [this.state.selectedTranscriptIds![0]],
        showAdvancedSettings: !this.state.showAdvancedSettings,
      });
    } else {
      this.setState({showAdvancedSettings: !this.state.showAdvancedSettings});
    }
  };

  handleTranscriptSelectionChange = (event: SelectChangeEvent): void => {
    // The chaining seems to iterate over the HTMLOptionsCollection as an array of individual HTMLOptionElement objects
    // but the underscore types do not detect that automatically.
    const newSelectedTranscriptIds = _.chain(event.target.options as unknown as Array<HTMLOptionElement>)
      .filter((option) => option.selected && option.value !== 'None')
      .map((option) => option.value)
      .value();
    this.setState({
      selectedTranscriptIds: newSelectedTranscriptIds,
      cdna: this.state.cdna && newSelectedTranscriptIds.length <= 1,
    });
  };

  renderResults = (): JSX.Element => {
    const {loading, result, selectedGeneId, selectedTranscriptIds, showAdvancedSettings} = this.state;
    if (result == null) {
      if (loading) {
        return <div className="faded">Loading...</div>;
      } else {
        return <div />;
      }
    }
    if (result.versions == null) {
      return (
        <div>
          <div className={classNames({faded: loading})}>No results found.</div>
          <GenomeImportHelpText />
        </div>
      );
    }

    // eslint-disable-next-line no-restricted-syntax
    const {gene, chromosome, transcripts} = _.find(result.versions, ({gene}) => gene.id === selectedGeneId)!;
    return (
      <form className={classNames('form-horizontal', {'faded u-no-mouse-target': loading})}>
        <FormGroup>
          <Label sm={3}>Genome</Label>
          <Col sm={6}>
            <select
              onChange={this.handleVersionChange}
              value={this.state.selectedGeneId!}
              {...getTestProps({component: 'ImportGeneInput', element: 'genomeSelect'})}
            >
              {Array.from(result.versions).map((version) => (
                <option value={version.gene.id} key={version.gene.id}>
                  {genomeToName(version.genome)}
                </option>
              ))}
            </select>
            <GenomeImportHelpText />
          </Col>
        </FormGroup>
        <FormGroup>
          <Label sm={3}>Gene</Label>
          <Col
            sm={6}
            className={classNames('u-input-line-height', css(styles.formLineHeight))}
            dataTestAttrs={{component: 'ImportGeneInput', element: 'geneName'}}
          >
            {geneToName(gene)}
          </Col>
        </FormGroup>
        <FormGroup>
          <Label sm={3}>Location</Label>
          <Col sm={6} className={classNames('u-input-line-height', css(styles.formLineHeight))}>
            <div>{locationToName(chromosome, gene.start, gene.end, gene.strand)}</div>
            {gene.strand === -1 ? (
              <div>
                <input
                  type="checkbox"
                  checked={this.state.revcomp}
                  onChange={(e) => {
                    this.setState({revcomp: e.target.checked});
                  }}
                />
                {' Import in sense orientation'}
              </div>
            ) : null}
          </Col>
        </FormGroup>
        <FormGroup>
          <Label sm={3}>
            {'Transcript '}
            <HelpTooltip
              text="Exons and CDS (if present) will be annotated from this transcript."
              className="u-tiny-spacing-left"
            />
          </Label>
          <Col sm={6}>
            <select
              multiple={showAdvancedSettings}
              value={showAdvancedSettings ? selectedTranscriptIds! : selectedTranscriptIds![0]}
              onChange={this.handleTranscriptSelectionChange}
              className={classNames({'transcript-selector': showAdvancedSettings})}
            >
              {!showAdvancedSettings ? <option value={undefined}>None</option> : undefined}
              {Array.from(transcripts).map((transcript) => (
                <option className="transcript-selector-option" value={transcript.id} key={transcript.id}>
                  {transcriptToName(transcript)}
                </option>
              ))}
            </select>
            {showAdvancedSettings ? (
              <div className="u-tiny-spacing-top">
                <input
                  type="checkbox"
                  disabled={selectedTranscriptIds!.length > 1}
                  checked={this.state.cdna}
                  onChange={(e) => {
                    this.setState({cdna: e.target.checked});
                  }}
                />
                {' Import cDNA only'}
              </div>
            ) : null}
          </Col>
        </FormGroup>
        {showAdvancedSettings ? (
          <FormGroup>
            <Label sm={3}>Upstream bp</Label>
            <Col sm={6}>
              <input
                type="number"
                min={0}
                value={this.state.upstream}
                onChange={(e) => {
                  this.setState({upstream: e.target.value});
                }}
              />
            </Col>
          </FormGroup>
        ) : undefined}
        {showAdvancedSettings ? (
          <FormGroup>
            <Label sm={3}>Downstream bp</Label>
            <Col sm={6}>
              <input
                type="number"
                min={0}
                value={this.state.downstream}
                onChange={(e) => {
                  this.setState({downstream: e.target.value});
                }}
              />
            </Col>
          </FormGroup>
        ) : undefined}
        <FormGroup>
          <Label sm={3}>Sequence Name</Label>
          <Col sm={6}>
            <input
              type="text"
              value={this.state.sequenceName}
              onChange={(e) => {
                this.setState({sequenceName: e.target.value});
              }}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Label sm={3}>{DEFAULT_PROJECT_FOLDER_LABEL_TEXT}</Label>
          <Col sm={6}>
            <FolderSelector
              showInventory={true}
              value={this.state.folderId}
              onChange={(e) => {
                this.setState({folderId: e.target.value});
              }}
              unsetOnFetchFail={true}
            />
          </Col>
        </FormGroup>
        {this.props.enableAdvancedSettings ? (
          <FormGroup className="text-right">
            <Col sm={4} className="col-sm-offset-8">
              <a onClick={this.toggleAdvancedSettings}>
                {showAdvancedSettings ? 'Hide advanced settings' : 'Show advanced settings'}
              </a>
            </Col>
          </FormGroup>
        ) : undefined}
      </form>
    );
  };

  override state: State = this.getState(this.props);

  override render(): JSX.Element {
    return (
      <div>
        <Row>
          <Col sm={9}>
            <div>
              <SearchInput
                ref={this.searchRef}
                query={this.state.query}
                placeholder="Search by Ensembl gene ID or name (e.g. BRCA2)"
                doSearch={this.search}
              />
            </div>
          </Col>
          <Col sm={3}>
            <div className="u-input-line-height">
              <a onClick={this.searchExample}>Example</a>
            </div>
          </Col>
        </Row>
        <div className="u-spacing-top">{this.renderResults()}</div>
      </div>
    );
  }
}

export default ImportGeneInput;

function __guard__<T, V>(value: Optional<T>, transform: (t: T) => V): V | undefined {
  return value != null ? transform(value) : undefined;
}

const styles = StyleSheet.create({
  formLineHeight: {
    lineHeight: '32px',
  },
});
